// src/pages/comercial/components/CriarObjetivosAccMulti.js
import React, { useMemo } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const ACC_SX = {
  backgroundColor: "#fff7f0",
  borderRadius: 2,
  "&:before": { display: "none" },
};

const ACC_SUM_SX = {
  minHeight: 32,
  px: 1.5,
  "& .MuiAccordionSummary-content": { margin: "4px 0" },
};

export default function CriarObjetivosAccMulti({
  panelKey,
  expandedPanel,
  onChange,

  title,
  options, // [{value,label}]
  selected, // array of values
  setSelected,

  disabled = false,
  hint = null, // string
  emptyHint = null, // string
  minWidthItem = 240,
}) {
  const allValues = useMemo(() => (options || []).map((o) => o.value), [options]);
  const isAll = useMemo(
    () => selected?.length > 0 && selected.length === allValues.length,
    [selected, allValues]
  );

  const toggleAll = () => setSelected(isAll ? [] : allValues);

  const toggleOne = (val) => {
    setSelected((prev) => (prev.includes(val) ? prev.filter((x) => x !== val) : [...prev, val]));
  };

  return (
    <Accordion
      expanded={expandedPanel === panelKey}
      onChange={onChange(panelKey)}
      disableGutters
      sx={ACC_SX}
      disabled={disabled}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />} sx={ACC_SUM_SX}>
        <MDTypography variant="button" sx={{ fontSize: 12 }}>
          {title}
        </MDTypography>
      </AccordionSummary>

      <AccordionDetails sx={{ pt: 0, pb: 1.5, px: 1.5 }}>
        <MDBox mb={0.5}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={isAll}
                onChange={toggleAll}
                disabled={disabled || allValues.length === 0}
              />
            }
            label={<span style={{ fontSize: 12 }}>Selecionar / desselecionar todos</span>}
          />
        </MDBox>

        <MDBox display="flex" flexWrap="wrap" gap={1}>
          {(options || []).map((o) => (
            <MDBox key={o.value} sx={{ minWidth: minWidthItem }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={(selected || []).includes(o.value)}
                    onChange={() => toggleOne(o.value)}
                    disabled={disabled}
                  />
                }
                label={<span style={{ fontSize: 13 }}>{o.label}</span>}
              />
            </MDBox>
          ))}
        </MDBox>

        {hint && (
          <MDBox mt={1}>
            <MDTypography variant="caption" color="text">
              {hint}
            </MDTypography>
          </MDBox>
        )}

        {emptyHint && (options || []).length === 0 && (
          <MDBox mt={1}>
            <MDTypography variant="caption" color="text">
              {emptyHint}
            </MDTypography>
          </MDBox>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
